export default __webpack_public_path__ + "static/media/copy.9d9c184e.svg";